import { SpinnerContainer, Spinner } from "./Loader.styles";

const Loader = () => (
  <SpinnerContainer>
    <Spinner />
  </SpinnerContainer>
);

export default Loader;
